var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.349 19.2372C11.4366 20.0428 7.25064 20.446 2.99298 19.2372C1.33471 18.7666 0 17.7197 0 16.2172C0 14.701 1.38196 13.7452 3.03516 13.1922C6.44829 12.05 10.2508 11.9123 14.3068 13.1922C15.9701 13.7169 17.342 14.701 17.342 16.2172C17.342 17.7197 16.0115 18.7774 14.349 19.2372Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.671 10.9832C11.7458 10.9832 14.2385 8.52452 14.2385 5.49159C14.2385 2.45867 11.7458 0 8.671 0C5.59616 0 3.10352 2.45867 3.10352 5.49159C3.10352 8.52452 5.59616 10.9832 8.671 10.9832Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3421 6.67798C15.8741 6.67798 14.6841 7.85178 14.6841 9.29978C14.6841 10.7478 15.8741 11.9216 17.3421 11.9216C18.8101 11.9216 20.0001 10.7478 20.0001 9.29978C20.0001 7.85178 18.8101 6.67798 17.3421 6.67798ZM17.3421 7.66537C17.5041 7.66537 17.6606 7.6895 17.8087 7.73236L15.753 9.75998C15.7096 9.61393 15.6851 9.45956 15.6851 9.29978C15.6851 8.39727 16.4267 7.66578 17.3417 7.66578L17.3421 7.66537ZM17.3421 10.9338C17.1801 10.9338 17.0236 10.9096 16.8756 10.8668L18.9312 8.83916C18.9746 8.98521 18.9991 9.13958 18.9991 9.29936C18.9991 10.2019 18.2575 10.9334 17.3425 10.9334L17.3421 10.9338Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivo);
export default __webpack_public_path__ + "static/media/inactivo.3ebd6d1bfbb14914a02d863f711cbec6.svg";
export { ForwardRef as ReactComponent };